module.exports = __webpack_public_path__ + "img/ELandwaterloo.0bb49c97.png";